import { useCallback, useEffect } from "react";
import Cookie from "js-cookie";
import { fcmGetToken, fcmGetMessage } from "Utils/fcmKit";
import { generateDeviceId } from "Utils/generateAgent";

import { fetchFcmRegister } from "Utils/http/register";
import { useNotification } from "GlobalStore/notification";
import PropTypes from "prop-types";
import firebase from "../../firebase";

export const FcmNotification = ({ ...props }) => {

	// Fungsi helper untuk delay
	const delay = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

	// register only once & send to be
	const registerFcmToken = useCallback((messaging) => {

		fcmGetToken(messaging, props.isMobile, async (fcmToken) => {

			if (!fcmToken) return;

			const oldPlatform = "home-review";
			const cookiesFcm = Cookie.get("fcm_tkn");
			const jwtToken = Cookie.get("token") || "";
			const username = Cookie.get("usrname");

			// perrsist id sebagai trigger untuk update semua deviceId dengan nilai yg
			// sama dng format username-timestamp untuk semua aplikasi
			let perssistenDeviceId = Cookie.get("perssitent_id");
			const notifyServiceWorkerWithPlatformId = () => {

				const idPlatform = Cookie.get("platform_id");

				if ("serviceWorker" in navigator && idPlatform) {

					navigator.serviceWorker.ready.then((registration) => {

						if (registration.active) {

							registration.active.postMessage({ idPlatform });

						}

					});

				}

			};
			// apabila perssistid belum ada
			if (!perssistenDeviceId) {

				const generatedId = generateDeviceId(
					username,
					false,
					oldPlatform,
				);

				Cookie.set("perssitent_id", generatedId, {
					domain: `.femaledaily.${
						["production", "staging"].includes(
							process.env.NEXT_PUBLIC_NODE_ENV,
						)
							? "com"
							: "net"
					}`,
				});

				Cookie.set("platform_id", oldPlatform, {
					domain: `.femaledaily.${
						process.env.NEXT_PUBLIC_NODE_ENV === "development" ? "net" : "com"
					}`,
				});

				notifyServiceWorkerWithPlatformId();
				// Tunggu sebentar supaya cookie tersimpan
				await delay(500); // opsional, kasih waktu untuk simpan
				perssistenDeviceId = generatedId;

			}

			const newDeviceId = generateDeviceId(
				username,
				perssistenDeviceId,
				oldPlatform,
			);

			const registerToken = async () => {

				await fetchFcmRegister({
					authorization: jwtToken,
					body: {
						token: fcmToken,
						device_id: newDeviceId,
					},
				})
					.then(() => {

						Cookie.set("fcm_tkn", fcmToken);
						Cookie.set("device_id", newDeviceId);

					})
					.catch(() => {});

			};

			// if fcm available
			if (cookiesFcm) {

				// Cookie.set("fcm_tkn", fcmToken);
				// Cookie.set("device_id", newDeviceId);
				const refreshedFcmCookie = Cookie.get("fcm_tkn");

				if (refreshedFcmCookie !== fcmToken) {

					const alreadyRegis = Cookie.get("alreadyRegis");
					Cookie.set("fcm_tkn", fcmToken);
					Cookie.set("device_id", newDeviceId);

					if (!alreadyRegis) {

						Cookie.set("alreadyRegis", true);
						Cookie.remove("fcm_tkn");
						Cookie.remove("device_id");
						await registerToken();

					}

				}

			} else {

				await registerToken();

			}

		});

	}, []);

	const handlePushMessage = useCallback((messaging) => {

		fcmGetMessage(messaging, (message) => {

			const hasQuestionMark = /\?/.test(message?.data?.deeplink);

			useNotification.getState().addNotification({
				id: `notification-${message.fcmMessageId}`,
				category_notif: message.data.category,
				subcategory_notif: message.data.child_category,
				type_notif: message.data.type,
				body: message.data.message,
				type: "regular",
				notifId: message.data.notif_id,
				title: message.data.title,
				url: `${message?.data?.deeplink}${
					hasQuestionMark ? "&" : "?"
				}utm_source=web&utm_medium=web_push&utm_campaign=${
					message.data.type
				}`,
				buttonText: "SEE MORE",
			});

		});

	}, []);

	useEffect(() => {

		// let unsubscribe = null;
		if (firebase.messaging.isSupported()) {

			const messaging = firebase.messaging();

			// Jalankan pertama kali saat mount
			registerFcmToken(messaging);
			handlePushMessage(messaging);

		}

	}, []);

	return <></>;

};

FcmNotification.propTypes = {
	ismobile: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
};

FcmNotification.defaultProps = {
	ismobile: false,
};
